import { useLingui } from '@lingui/react/macro';
import Badge from 'carbon-react/lib/components/badge';
import Button from 'carbon-react/lib/components/button/__next__';
import Icon from 'carbon-react/lib/components/icon';
import { RenderOpenProps } from 'carbon-react/lib/components/popover-container';
import { JSX } from 'react';
import useNotifications from './hooks/useNotifications';

interface Props extends RenderOpenProps {}

const NotificationButton = ({ isOpen: _isOpen, ref, ...props }: Props): JSX.Element => {
  const { t } = useLingui();
  const notifications = useNotifications();

  const hasUnreadNotifications = notifications.some((notification) => !notification.pushIsRead);

  return (
    <span ref={ref}>
      <Button variantType="subtle" inverse aria-label={t`Notifications`} data-pendo-id="notifications" {...props}>
        {hasUnreadNotifications ? (
          <Badge size="medium">
            <Icon type="alert" color="white" />
          </Badge>
        ) : (
          <Icon type="alert" color="white" />
        )}
      </Button>
    </span>
  );
};

export default NotificationButton;
